import jQuery from 'jquery';
const $ = jQuery;

window.jQuery = $;
window.$ = $;

import 'cssuseragent';
import 'jquery.easing';

// import ImgLazyLoad from './module/img-lazy-load';
import Checkbox from './module/Checkbox';
import SceneManager from './module/SceneManager';

if (navigator.platform == "iPad" ||        // -iOS12
  (navigator.platform == "MacIntel" &&   // iPadOS
  navigator.userAgent.indexOf("Safari") != -1 &&
  navigator.userAgent.indexOf("Chrome") == -1 &&
  navigator.standalone !== undefined)) {
  // document.querySelector("meta[name='viewport']").setAttribute("content", "width=959");
}


class MainApp {
  constructor() {
    if(this.isTouchDevice()) {
      $('html').addClass('is-touch-device');
      $('a').attr('data-touch', 'true');
      $('button').attr('data-touch', 'true');
    } else {
      $('html').addClass('is-mouse-device');
    }

    this.$window              = $(window);
    this.windowWidth = this.$window.width();
    this.windowHeight = this.$window.height();
    // this.spMenu = new SpMenu();

    this.prevViewMode = '';

    this.sceneManager = new SceneManager(this, $('body').attr('data-init-scene'));

    /*
    if($('.BtnToggleSpMenu').css('display') == 'none') {
      this.viewMode = 'pc';
    } else {
      this.viewMode = 'sp';
    }
    */
    // console.log(this.viewMode);

    $('.js-open-modal').on('click', () => {
      $('.Fullscreen').addClass('Fullscreen--show');
      return false;
    });
    $('.js-close-modal').on('click', () => {
      $('.Fullscreen').removeClass('Fullscreen--show');
      return false;
    });

    $('.js-open-modal-prize').on('click', () => {
      $('.PrizeModal').addClass('PrizeModal--show');
      return false;
    });
    $('.js-close-modal-prize').on('click', () => {
      $('.PrizeModal').removeClass('PrizeModal--show');
      return false;
    });

    /*
    $(document).on('click', '.RadioBtnList', (e) => {
      $(e.currentTarget).addClass('RadioBtnList--checked');
      $(e.currentTarget).next('.Choices__execute').find('.Btn').removeClass('Btn--disable');
    });
    */

    $('.Checkbox').each((i, e) => {
      new Checkbox($(e))
    });


    this.onLoad();

  }

  isTouchDevice() {
    return ('ontouchstart' in window || navigator.msPointerEnabled) ? true : false;
  }

  init() {


    // this.viewMode             = 'pc';
    this.isTablet             = false;
    this.onLoadComplete       = true;

    this.isShowProjectFooter = true;
    // this.imgLazyLoad          = new ImgLazyLoad(this);
    // this.spMenu               = new SpMenu(this);



    // シェアボタン
    /*$('.js-btn-share').on('click', (e) => {
      let shareText = document.title;
      if(!$('body').hasClass('home')) {
        shareText = shareText.replace('NIPPONIA - なつかしくて、あたらしい、日本の暮らしをつくる', 'NIPPONIA');
      }

      socialButton($(e.currentTarget).attr('data-type'), location.href, shareText);
      return false;
    });*/



    this.$window
      .on('resize', ()=>{
        this.onWindowResize();
      })
      .on('scroll', ()=>{
        this.onWindowScroll();
      });

  }

  onWindowScroll() {
    this.scrollTop = this.$window.scrollTop();
    if(this.scrollTop < 0) this.scrollTop = 0;


    if(this.scrollTop != this.prevScrollTop) {
      if(this.scrollTop > this.prevScrollTop) {
        this.scrollDiff = 1;
      } else {
        this.scrollDiff = -1;
      }
    }



    this.prevScrollTop = this.scrollTop;

    // this.imgLazyLoad.update(this.scrollTop, this.windowHeight);
  }


  onWindowResize() {
    this.windowWidth = this.$window.width();
    this.windowHeight = this.$window.height();

    // if(this.prevViewMode != this.viewMode) {
    // }

    //

    if($('.Fullscreen__content').height() < $('.ModalBody').outerHeight() + 56) {
      $('.ModalScroller__inner').addClass('ModalScroller__inner--overflow');
      $('.ModalScroller').css('height', $('.Modal').height() - 56);
    } else {
      $('.ModalScroller__inner').removeClass('ModalScroller__inner--overflow');
      $('.ModalScroller').css('height', 'auto');
    }

    // 背景の比率
    // 0.587774295
    if(this.windowWidth / this.windowHeight > 0.58) {
      $('.Background').addClass('Background--contain');
    } else {
      $('.Background').removeClass('Background--contain');
    }

    // console.log('outerHeight', $('.ModalBody').outerHeight());
    // $('.ModalScroller').css('height', $('.Modal').height() - 56);

    this.prevViewMode = this.viewMode;


    this.onWindowScroll();
  }


  onLoad() {
    let jsonLoadInterval = setInterval(() => {
      if(window.onLoadCompleteJson) {
        clearInterval(jsonLoadInterval);

        this.init();
        this.onWindowResize();

        $('.Header').removeClass('Header--loading');
        $('.Loading').animate({'opacity':0}, 400, 'easeInOutSine', () => {
          $('.Loading').css('display', 'none');
        });

      }
    }, 1000 / 30);

  }
}





window.onLoadCompleteJson = false;

$.getJSON('./data.json' , (data) => {
  window.data_kai = $(data);
  window.onLoadCompleteJson = true;
});

$('document').ready(() => {
  // console.log('KAI Sound Lab');

  $(document).on('touchstart', 'a, button, label', (e) => {
    $(e.currentTarget).attr('data-touch', 'true');
  });

  $(document).on('mouseleave', 'a, button, label', (e) => {
    $(e.currentTarget).removeAttr('data-touch');
  });
});

$(window).on('load', () => {
  let jsonLoadInterval = setInterval(() => {
    if(window.onLoadCompleteJson) {
      clearInterval(jsonLoadInterval);

      // console.log('DOM & JSON Load complete');
      // console.log('json:', window.data_kai.length);

      new MainApp();
    }
  }, 1000 / 30);
});


